import { Link } from "react-router-dom";
import { AssetManager } from "utils/AssetManager";

export const StoryDetails = (props: {
    playerName: string;
    voteCount: number;
    reactionCount: number;
    characterId?: number;
    isPerfect: boolean;
    url?: string;
}) => {
    const { playerName, reactionCount, voteCount, characterId, isPerfect, url } = props;
    const { characters } = AssetManager;

    const c = characterId != null ? characters[characterId] : null;

    return (
        <div className="d-flex justify-content-center">
            <div>
                {c && (
                    <div className="d-flex gap-2">
                        <div
                            className="text-white d-block text-truncate align-items-center h6 text-lg-nowrap mt-auto pb-2 text-start"
                            style={{ width: 120 }}
                        >
                            {playerName && (
                                <div>
                                    {url ? (
                                        <Link target="_blank" className="link-white pb-0" to={url}>
                                            {playerName}
                                        </Link>
                                    ) : (
                                        playerName
                                    )}
                                </div>
                            )}
                        </div>

                        <div style={{ width: 48 }}>
                            <img src={c} alt="" className="img-fluid" />
                        </div>
                    </div>
                )}

                <div
                    style={{ width: 180 }}
                    className="fw-bold bg-white text-dark p-1 text-nowrap d-inline-flex rounded border border-dark z-1"
                >
                    <div className="border border-light rounded p-2 d-flex gap-2 gap-lg-0 align-items-center align-items-lg-start justify-content-between flex-grow-1 position-relative">
                        <div>
                            {voteCount} {voteCount === 1 ? "vote" : "votes"}
                        </div>

                        {reactionCount > 0 && <div>{reactionCount} ❤️</div>}

                        {isPerfect && (
                            <div className="position-absolute top-0 start-0 translate-middle">
                                <span className="badge bg-success">100%</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
